import { convertDateToUIFormat } from '../converters/dateConverters';

export default (sentAt, formatMessage) => {
  const dateStr = sentAt ? convertDateToUIFormat(sentAt, formatMessage) : null;
  return dateStr ? `(${dateStr})` : '';
};



// WEBPACK FOOTER //
// ./src/utils/survey/getDateStr.js